<template>
  <!-- mcf-light/mcf-dark 切換日夜模式-->
  <div class="h-100 d-flex flex-column mcf-light">
    <div class="flex-grow-1 overflow-auto ">
      <slot name="content"></slot>
    </div>
    <div class="position-sticky" style="bottom:0">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
};
</script>

<style>

</style>
